/* VIPA 7-day wiper sale: display only, checkout discount remains Shopify-managed. */
(function () {
  'use strict';
  var start = Date.parse('2026-10-14T10:18:00Z');
  var end = Date.parse('2026-10-21T10:18:00Z');
  var path = location.pathname.replace(/\/$/, '');
  if (path !== '/collections/wipers-for-your-vehicle') return;
  if (Date.now() < start || Date.now() >= end) return;
  function applySale() {
    document.querySelectorAll('#product-grid .product-card-wrapper').forEach(function (card) {
      var price = card.querySelector('.price');
      if (!price || price.dataset.vipaSevenDaySale === '1') return;
      var sale = price.querySelector('.price__sale .price-item--sale');
      if (!sale) return;
      var displayed = sale.textContent || '';
      var match = displayed.match(/(?:£\s*|GBP\s*)([\d,]+(?:\.\d{1,2})?)/i);
      if (!match) return;
      var rawPence = Math.round(Number(match[1].replace(/,/g, '')) * 100);
      if (!Number.isFinite(rawPence) || rawPence < 100) return;
      var salePence = Math.round(rawPence * 0.95);
      if (salePence >= rawPence) return;
      var money = function (p) { return '£' + (p / 100).toFixed(2); };
      var crossed = document.createElement('s');
      crossed.className = 'price-item price-item--regular vipa-original-price';
      crossed.textContent = money(rawPence);
      crossed.style.cssText = 'color:#666;margin-right:8px;font-weight:500;text-decoration:line-through;';
      sale.before(crossed);
      sale.textContent = money(salePence);
      sale.style.cssText = 'color:#0000ff;font-weight:800;';
      price.classList.add('price--on-sale');
      var note = document.createElement('small');
      note.className = 'vipa-weekend-price-note';
      note.textContent = '5% off automatically at checkout';
      note.style.cssText = 'display:block;margin-top:5px;color:#0000ff;font-size:12px;font-weight:600;';
      price.after(note);
      price.dataset.vipaSevenDaySale = '1';
    });
  }
  var scheduled = false;
  var scheduleApply = function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; applySale(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applySale);
  else applySale();
  new MutationObserver(scheduleApply).observe(document.documentElement, { childList:true, subtree:true });
})();